<template>
    <div class="videoSliderSection">
        <slide-show :slides="slides"
                    :index.sync="localIndex"
                    :auto="!transitioning"
                    :interval="interval"
                    data-delay="delay"
                    :delay="interval"
                    :css="false"
                    :enter="enter"
                    :leave="leave"
                    :loop="true"
                    :pagination="false"
                    @before-enter="onBeforeEnter"
                    :startingSlide="0"
                    ref="slideshow"
        >
            <div class="slide" slot="slide" slot-scope="args">
                <home-slide :slide="args.slide" :index="args.index"
                       :class="[{'slide-theme--invert': isWhiteBg(args.slide)}]"
                       ref="slide"
                ></home-slide>
            </div>
        </slide-show>

        <div class="pagiNaviContainer">
            <div class="slider-pagination">
                <span v-for="(slide, index) in slides"
                      :class="['slider-pagination-bullet', {'slider-pagination-bullet-active': isActiveSlide(index)}]"
                      @click="go(index)"
                ></span>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'
    import _throttle from 'lodash/throttle'
    import slideshow from '../animations/slideshow'

    export default {
        mixins: [],
        props: ['slides', 'delay', 'sliding'],
        data() {
            return {
                interval: 4500,
                show: false,
                transitioning: false,
                transitioningBackup: null,
                localIndex: null,
                style: null,
                hasWhiteBg: false,
                hammertime: null,
            }
        },
        computed: {
            ...mapGetters('ui', [
                'isMobile',
            ]),
        },
        created() {
            document.addEventListener('visibilitychange', this.onVisibilityChange, false);
        },
        beforeDestroy() {
            document.removeEventListener('visibilitychange', this.onVisibilityChange);
        },
        mounted() {
            //console.log('carousel: mounted')
            //debugger
            this.containerInner = document.querySelector('.editorsSection .container__inner')
            this.onSlideTap()
            this.clearInvertTheme()
        },
        watch: {},
        methods: {
            ...mapActions('ui', [
                'invertTheme',
            ]),
            onBeforeEnter(el) {
                //debugger
                el.style.opacity = 0
            },
            enter() {
                this.sliding
                    ? slideshow.enter(...arguments)
                    : slideshow.enter_wo_slide(...arguments)
            },
            leave() {
                this.sliding
                    ? slideshow.leave(...arguments)
                    : slideshow.leave_wo_slide(...arguments)
            },
            onVisibilityChange() {
                if (document.visibilityState !== 'visible') {
                    this.transitioningBackup = this.transitioning
                    this.transitioning = true
                } else {
                    this.transitioning = this.transitioningBackup
                }

                //console.log('onVisibilityChange', document.visibilityState)
            },
            onSlideTap() {
                this.hammertime = new Hammer(this.$refs.slideshow.$el)
                this.hammertime.on('tap', (ev) => {
                    this.$refs.slide.onTap(ev.target)
                })
            },
            isActiveSlide(index) {
                return this.localIndex === index || this.localIndex == null && index === 0
            },
            isWhiteBg(slide) {
                //console.log('isWhiteBg', slide)

                // TODO check with posters
                if (!slide || !slide._loaded) {
                    return false
                }

                let keywords = slide.keywords || []
                let hasWhiteBg = keywords.indexOf('WHITE BG') !== -1
                this.invertTheme(hasWhiteBg)

                return hasWhiteBg
            },
            clearInvertTheme() {
                if (!this.slides.length) {
                    this.invertTheme(false)
                }
            },
            next() {
                this.$refs.slideshow.manualNext()
            },
            prev() {
                this.$refs.slideshow.manualPrev()
            },
            go(index) {
                this.$refs.slideshow.goTo(index)
            },
        },
    }
</script>


